import { MODAL_REGISTER } from '../constants/ActionTypes';

/**
 * Stores the root modal and performs actions on it
 */
const modal = (state = {}, action) => {
  if (action.type === MODAL_REGISTER) {
    return action.payload;
  } else {
    return state;
  }
};

export default modal;
